export default "__VITE_ASSET__CjV2GfqJ__"